module.exports = __webpack_public_path__ + "static/media/play-gray.dad1a73e.svg";